<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    max-width="500"
    content-class="edit-profile"
  >
    <!-- <div class="fill-height display-flex" style="flex-grow:1"> -->
    <!--     <v-container fluid fill-height class="xs-only-px-0 pa-2">
      <v-layout>
        <v-flex xs12> -->

    <v-tabs
      v-model="activeTab"
    >
      <v-tab>
        Profile
      </v-tab>

      <v-tab>
        Password
      </v-tab>
      <v-tab>
        Saved Data
      </v-tab>
    </v-tabs>
    <v-tabs-items
      ref="tabsItems"
      v-model="activeTab"
      class="pos-rel"
      style="overflow: hidden;"
    >
      <v-tab-item>
        <v-card>
          <v-card-text v-if="loading">
            <div class="mt-2 display-flex align-center justify-center">
              <v-progress-circular
                :indeterminate="true"
                color="primary"
              />
            </div>
          </v-card-text>
          <v-form
            v-else
            ref="profileForm"
            v-model="profileFormValid"
            @submit.prevent="save"
          >
            <v-card-text>
              <v-text-field
                ref="email"
                v-model="profileUser.email"
                autofocus
                :disabled="true"
                label="Email*"
                required
              />
              <v-text-field
                ref="name"
                v-model="profileUser.name"
                :rules="[validateRequired, (v) => nameValid(v) || 'Please enter at least a given name and last name.']"
                autofocus
                label="Name*"
                required
              />
              <div v-if="profileUser.accountType === 'lawyer'">
                <!-- TODO MVP just for lawyers for now -->
                <v-textarea
                  v-if="profileUser.accountType !== 'individual'"
                  ref="bio"
                  v-model="profileUser.bio"
                  class="font-size-12-not-label"
                  :rules="[(v)=>{return profileUser.accountType !== 'lawyer' || validateRequired}]"
                  :label="`Bio${profileUser.accountType === 'lawyer' ? '*': ''}`"
                  v-bind="{required: profileUser.accountType === 'lawyer'}"
                  rows="4"
                />
              </div>

              <div class="mt-2">
                <label class="v-label--theme-light mt-3 mb-2 block font-size-13">
                  Profile Photo
                </label>

                <!-- TODO: fix: Chrome now shows warning about cross-site cookies with Gravatar -->
                <v-textarea
                  ref="photoURL"
                  v-model="profileUser.photoURL"
                  prepend-icon="mdi-link"
                  :rules="[photoURLRules]"
                  label="Photo URL"
                  auto-grow
                  rows="1"
                  class="pt-2"
                  hint="Only Gravatar or uploaded images allowed."
                  :persistent-hint="true"
                />

                <v-alert
                  type="info"
                  outlined
                  :value="formDirty && uploadProgress === 100"
                >
                  Your photo has been uploaded, but you still need to hit 'Save' to use that image for your profile.
                </v-alert>

                <label class="v-label--theme-light pt-2 d-block accent--text ml-3">
                  OR
                </label>

                <div>
                  <fileInput
                    ref="photoFileInput"
                    v-model="photoFilename"
                    accept="image/*"
                    label=""
                    placeholder="Select a photo"
                    hint="(You can drag and drop on desktop)"
                    :persistent-hint="true"
                    class="grow pos-rel"
                    field-class="pt-2"
                    @click.stop.prevent
                    @files="(evtfiles) => {photoFile = evtfiles; photoFileDirty = true}"
                    @formdata="(evtformdata) => {photoFormData = evtformdata[0]}"
                  /><!-- TOOD fix bug where file dialog cancel clears form data -->

                  <v-btn
                    v-if="uploadProgress === 0 || uploadProgress === 100"
                    :loading="uploading"
                    :disabled="!photoFileDirty || uploadedPhotoValid !== true || !photoFile.length"
                    small
                    text
                    color="primary"
                    class="mr-0"
                    @click="uploadProfileImage"
                  >
                    Upload
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="uploading || !photoFileDirty"
                    small
                  >
                    <v-progress-linear v-model="uploadProgress" />
                  </v-btn>
                </div>

                <div class="edit-profile-avatar">
                  <v-avatar
                    size="128"
                    :class="{'error--text':!photoValid}"
                  >
                    <img
                      :src="photoObjectURL || profileUser.photoURL || noAvatarSrc"
                      alt="avatar"
                      @load="photoValid = true"
                      @error="photoValid = false"
                    >
                  </v-avatar>
                  <small class="grey--text">
                    {{ photoNaturalWidth && photoNaturalHeight ? `${photoNaturalWidth} &times; ${photoNaturalWidth}`: '&nbsp;' }}
                  </small>
                  <span
                    v-show="photoObjectURL && uploadedPhotoValid !== true"
                    class="error--text"
                  >
                    {{ uploadedPhotoValid }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                small
                text
                @click="$emit('close')"
              >
                {{ formDirty ? 'Cancel' : 'Close' }}
              </v-btn>
              <v-btn
                ref="save"
                :loading="saving"
                :disabled="saving || !formDirty || !photoValid"
                color="primary"
                class="right"
                small
                type="submit"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-form
              ref="passwordForm"
              v-model="passwordFormValid"
            >
              <v-text-field
                ref="currentPassword"
                v-model="currentPassword"
                :rules="passwordRules"
                :required="passwordRequired"
                label="Current Password"
                type="password"
                @input="passwordFormDirty = true"
                @keyup.enter="$refs.password.focus()"
              />
              <v-text-field
                ref="password"
                v-model="password"
                :rules="passwordRules"
                :required="passwordRequired"
                label="New Password"
                type="password"
                @input="passwordFormDirty = true"
                @keyup.enter.native="changePassword"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              text
              @click="$emit('close')"
            >
              {{ passwordFormDirty ? 'Cancel' : 'Close' }}
            </v-btn>
            <v-btn
              ref="changePassword"
              :loading="changingPassword"
              :disabled="changingPassword || !passwordFormDirty"
              color="primary"
              class="right"
              small
              text
              @click="changePassword"
            >
              Change
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-container
              grid-list-xs
              class="pa-0"
            >
              <v-layout
                row
                wrap
              >
                <template v-for="(value, key) in profileData.profileFields">
                  <v-flex
                    v-show="value !== null"
                    :key="key"
                    xs12
                  >
                    <v-text-field
                      :label="key"
                      :value="value"
                      disabled
                    />
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              text
              @click="$emit('close')"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-dialog>
</template>

<script>

import { firebase, fsdb, projectId } from '../firebase'
import fileInput from '@/components/utils/file-input.vue'
import { validateRequired } from '@/utils/validationRules'

import cloneDeep from 'lodash/cloneDeep'

const metaFields = new Set(['created', 'createdBy', 'modified', 'modifiedBy'])
const ignoreFieldsWith = ['.key', 'addressManualEntry']

const projectStorageUrlRE = new RegExp(`https://firebasestorage.googleapis.com.*${projectId}.appspot.com`)
const externalUrlRE = new RegExp('https://www.gravatar.com/avatar/')

export default {
  name: 'EditProfile',
  components: { fileInput },
  props: { showDialog: { type: Boolean, default: false }, uid: { type: String, default: '' } },
  data: function () {
    return {
      loading: true,
      activeTab: null,
      appUser: {
        email: '',
        name: '',
        bio: '',
        photoURL: '',
        account: {}
      },
      profileUserUid: null,
      profileUser: {
        email: '',
        name: '',
        bio: '',
        photoURL: '',
        account: {}
      },

      profileFormValid: true,
      passwordFormValid: true,
      photoSource: null,
      photoURL: '',
      photoValid: false,
      photoUploadDialog: false,
      photoFilename: '',
      photoFile: {},
      photoFileDirty: false,
      photoFormData: {},
      photoObjectURL: '',
      photoNaturalWidth: 0,
      photoNaturalHeight: 0,
      photoType: '',
      currentPassword: '',
      password: '',
      profileDataLoading: true,
      passwordRules: [],
      passwordRequired: false,
      passwordFormDirty: false,
      saving: false,
      changingPassword: false,
      uploading: false,
      uploadProgress: 0,
      scrollbarRefs: ['tabsItems']
    }
  },
  computed: {
    profileData: function () {
      if (this.profileDataLoading) { return {} }

      const profile = Object.entries(this.profile).reduce((acc, [key, value]) => {
        if (ignoreFieldsWith.some(ignore => key.includes(ignore))) { return acc }

        if (metaFields.has(key)) {
          acc.metaFields[key] = value.toDate ? value.toDate().toLocaleString() : value
        } else {
          acc.profileFields[key] = value
        }

        return acc
      }, { profileFields: {}, metaFields: {} })
      return profile
    },
    uploadedPhotoValid: function () {
      const maxPhotoSize = 278
      if (this.photoNaturalWidth > maxPhotoSize || this.photoNaturalHeight > maxPhotoSize) { return 'Photo must be less than or equal to 278x278 and square.' }
      if (this.photoNaturalWidth !== this.photoNaturalHeight) { return 'Photo must be square.' }
      if (!this.photoType.startsWith('image/')) { return 'Photo must be an image.' }
      return true
    },
    photoSourceComp: function () {
      if (this.profileUser.photoURL) {
        return projectStorageUrlRE.test(this.profileUser.photoURL) ? 'upload' : 'external'
      }
      return ''
    },
    formDirty: function () {
      const fields = ['name', 'photoURL', 'bio']
      return fields.some(field =>
        (this.appUser[field] || 'empty') !== (this.profileUser[field] || 'empty')
      )
    },
    photoURLDirty: function () {
      return this.appUser.photoURL !== this.profileUser.photoURL
    }
  },
  watch: {
    'uid': {
      handler: async function (newVal, oldVal) {
        var uid = this.uid
        this.profileDataLoading = true
        if (uid === '') {
          uid = this.$store.state.user.uid
          await this.appUserBinding
          this.appUser = { ...this.appUser, ...this.$store.state.appUser }
          this.profileUser = cloneDeep(this.appUser)
          await this.$binding('profile', fsdb.collection('users').doc(uid).collection('data').doc('profile'))
          this.profileDataLoading = false
        } else {
          await Promise.all([
            this.$binding('appUser', fsdb.collection('users').doc(uid)),
            this.$binding('profile', fsdb.collection('users').doc(uid).collection('data').doc('profile')).then(() => {
              this.profileDataLoading = false
            })
          ])
          this.profileUser = cloneDeep(this.appUser)
        }

        this.profileUserUid = uid
        this.loading = false

        // this.$updatePerfectScrollbars()
      },
      immediate: true
    },
    photoSourceComp: {
      handler: function (newVal, oldVal) {
        this.photoSource = newVal
      },
      immediate: true
    },
    'photoFile': {
      handler: function (newVal, oldVal) {
        this.photoNaturalWidth = 0
        this.photoNaturalHeight = 0
        this.photoObjectURL = ''
        if (newVal && newVal.length) {
          this.photoType = newVal[0].type

          var img = new Image()
          this.photoObjectURL = window.URL.createObjectURL(newVal[0])
          img.src = this.photoObjectURL
          img.onload = () => {
            this.photoNaturalWidth = img.naturalWidth
            this.photoNaturalHeight = img.naturalHeight
          }
        }
      }
    },
    'activeTab': async function (newVal, oldVal) {
      // this.$updatePerfectScrollbars()
    }
  },
  async beforeCreate() {
    this.dispatchActions(['checkAuth', 'get_appUser'])
    this.mapStates(['user', 'appUserBinding'])
    this.noAvatarSrc = '/img/noavatar.jpg'
  },
  mounted() {
    // this.$initPerfectScrollbars()
  },
  methods: {
    validateRequired,
    save: async function () {
      this.saving = true
      if (this.$refs.profileForm.validate(true)) {
        try {
          var updates = {
            name: this.profileUser.name,
            modifiedBy: this.profileUserUid,
            modified: firebase.firestore.FieldValue.serverTimestamp()
          }
          if (this.profileUser.photoURL) {
            updates.photoURL = this.profileUser.photoURL
          }

          if (this.profileUser.accountType === 'lawyer') { // TODO MVP just lawyers for now
            updates.bio = this.profileUser.bio
          }

          await fsdb.collection('users').doc(this.profileUserUid).update(updates)

          // auth user doesn't update realtime, so just overwrite state
          if (this.profileUserUid === this.user.uid) {
            this.$store.state.user.displayName = this.profileUser.name
            this.$store.state.user.photoURL = this.profileUser.photoURL
            this.appUser = { ...this.appUser, ...this.$store.state.appUser }
          }

          this.$showSuccessbar()
        } catch (e) {
          this.$Sentry.captureException(e)
          this.$showErrorbar(e.message || e)
        }
      }

      this.saving = false
    },
    changePassword: async function () {
      this.changingPassword = true
      this.passwordRules = [validateRequired, (v) => v.length >= 6 || 'Password should be at least 6 characters.']
      this.passwordRequired = true

      this.$refs.currentPassword.validate(true)
      this.$refs.password.validate(true)

      await this.$nextTick()

      if (this.passwordFormValid) {
        const user = firebase.auth().currentUser

        const credential = firebase.auth.EmailAuthProvider.credential(
          user.email,
          this.currentPassword
        )

        try {
          await user.reauthenticateAndRetrieveDataWithCredential(credential)
          await user.updatePassword(this.password)

          this.passwordRules = []
          this.passwordRequired = false
          this.currentPassword = ''
          this.password = ''
          this.passwordFormDirty = false

          this.$showSuccessbar()
        } catch (e) {
          this.$Sentry.captureException(e)
          this.$showErrorbar(e.message || e)
        }
      }
      this.changingPassword = false
    },
    uploadProfileImage: async function () {
      if (!this.uploadedPhotoValid) { return }

      this.uploading = true

      try {
        this.uploadProgress = 0
        await this.$firePost('profileImage/' + this.profileUserUid, firebase.auth(), this.photoFormData, undefined,
          progressEvent => {
            this.uploadProgress = (progressEvent.loaded * 100) / progressEvent.total
          })

        const url = await firebase.storage().ref('profileImages/' + this.profileUserUid).getDownloadURL()
        this.$set(this.profileUser, 'photoURL', url)
        this.photoFileDirty = false

        this.$showSuccessbar()
      } catch (e) {
        this.$Sentry.captureException(e)
        this.$showErrorbar(e.message || e)
      }

      this.uploading = false
    },
    photoURLRules(v) {
      if (!v) { return true }
      if (externalUrlRE.test(v) || projectStorageUrlRE.test(v)) { return true }
      return 'URL must be a https://www.gravatar.com/avatar/ URL or an uploaded image.'
    },
    nameValid() {
      return /\w\w+\s\S\w+/.test(this.profileUser.name)
    }
  }
}

</script>

<style lang="scss">
.edit-profile {
  display: flex;
  flex-direction: column;

  &-avatar {
    display: flex;
    justify-content: center;
  }
}
</style>
